import AOS from 'aos/dist/aos';


export default {
    init() {

        // scripts here run on the DOM load event
        //console.log('This is a page with the default template.');

        $('#landing-contact-form-btn').click(function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#landing-contact-form').offset().top - ($('#header').outerHeight() - 2),
            }, 1500);
        });

        // $('main').find('section').addClass('is-ready');

        AOS.init({
            duration: 600,
                delay: 400,
                // easing: 'reveal',
                // once: false, // whether animation should happen only once - while scrolling down
                // mirror: false, // whether elements should animate out while scrolling past them
                anchorPlacement: 'bottom', // defines which position of the element regarding to window should trigger the animation

        });

    },
    finalize() {
        // scripts here fire after init() runs
    },
    };



// WEBPACK FOOTER //
// ./scripts/routes/landing.js